import React from "react";
import Breadcrumb from "../components/Breadcrumb";

const CommonHeaderComp = ({ Heading, height,startPage, pageName , color}) => {
  return (
    <>
      <div className="common_container" style={{ height: height }}>
        <div className="common_heading d-flex flex-column">
          <h1 className="mb-2">{Heading}</h1>
          <Breadcrumb title={startPage ? startPage : "Home"} breadcrumbItem={pageName} />
        </div>
        <div className="common_container_bottom">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1000 100"
            fill={color ? color : "#ffecf0" }
            // style={{color: color ? color : "#ffecf0"}}
          >
            <path d="M0 0v60c9 0 18-3 25-10 13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s37 13 50 0c14-14 37-14 50 0 7 7 16 10 25 10V0H0Z"></path>
          </svg>
        </div>
      </div>
    </>
  );
};

export default CommonHeaderComp;
